import type { ReviewWithAvatar } from '@/lib/supabase/get-release-reviews'

/** Append a fetched page, dropping any review already on screen. Keyset
 *  pagination should never overlap, but the first page comes from the cached
 *  product render and the rest from the live API, so guard against it. */
export const mergeReviews = (existing: ReviewWithAvatar[], incoming: ReviewWithAvatar[]): ReviewWithAvatar[] => {
  const seen = new Set(existing.map((review) => review.id))
  const fresh = incoming.filter((review) => !seen.has(review.id))
  return fresh.length > 0 ? [...existing, ...fresh] : existing
}
